import type { ModuleManifest } from '@platform/shell';

// Inventory: Adora's hardware system of record (stock, serials, builds, purchase orders,
// counts). Product `hardware` — the Entra claims are inventory.* mapped to it (decision 86;
// platform ENTRA_ROLE_MAP). Switched off outside development until its API exists
// (PLATFORM_MODULES), because until Phase 2 its data still lives in each browser.
const manifest: ModuleManifest = {
  id: 'inventory',
  label: 'Inventory',
  product: 'hardware',
  order: 3,
  basePath: '/inventory',
  home: '/inventory/builds',
  load: () => import('./src/platform-entry.tsx'),
};

export default manifest;
